import { render, staticRenderFns } from "./TwoFAPopUp.vue?vue&type=template&id=ab87ffcc&scoped=true"
import script from "./TwoFAPopUp.vue?vue&type=script&lang=js"
export * from "./TwoFAPopUp.vue?vue&type=script&lang=js"
import style0 from "./TwoFAPopUp.vue?vue&type=style&index=0&id=ab87ffcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab87ffcc",
  null
  
)

export default component.exports